import React from 'react';
import { TableCell } from '@mui/material';

const CustomTableCell = (props) => {
  const { children, ...rest } = props;

  return (
    <TableCell className='!p-2' sx={{ fontSize: '12.5px' }} {...rest}>
      {children}
    </TableCell>
  );
};

export default CustomTableCell;
